import axios from "axios";
import { convertObjectToUrlParams } from "../helpers/convertObjToUrlParams";

export const listCatchReportsExport = async (params: any = {}) => {
  try {
    const response = await axios.get(
      `${
        process.env.REACT_APP_API
      }/CatchReport/export-list${convertObjectToUrlParams(params)}`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
